import React from 'react';
import style from './index.module.css';
import { getIcon } from '../../utils/utils';
import { motion } from 'framer-motion';
import { useTheme } from '@mui/material/styles';

const Card = (props) => {
	const theme = useTheme();
	const isDark = theme.palette.mode === 'dark';

	return (
		<motion.div 
			whileHover={{ 
				y: -10,
				transition: { duration: 0.3 }
			}}
			className={style.card}
			style={{
				backgroundColor: isDark ? 'rgba(255, 255, 255, 0.05)' : '#fff',
				border: `1px solid ${isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)'}`,
				boxShadow: isDark ? '0 10px 30px rgba(0,0,0,0.5)' : '0 10px 30px rgba(0,0,0,0.05)',
			}}
		>
			<div className={style.cardBody}>
				<motion.div 
					whileHover={{ scale: 1.2, rotate: 360 }}
					transition={{ type: 'spring', stiffness: 260, damping: 20 }}
					className={style.iconStyle}
					style={{ backgroundColor: theme.palette.primary.main }}
				>
					{getIcon(props.icon)}
				</motion.div>
				<p className={style.cardHeadingText} style={{ color: theme.palette.text.primary }}>
					{props.header}
				</p>
			</div>
		</motion.div>
	);
};

export default Card;
